<script>
export default {
  name: 'WorkOrderDetailHeader',
  props: {
    woNumber: {
      type: String,
      required: true,
    },
    statusLabel: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    previousStatusLabel: {
      type: String,
      default: '',
    },
    nextStatusLabel: {
      type: String,
      default: '',
    },
    canMovePreviousStatus: {
      type: Boolean,
      default: false,
    },
    canMoveNextStatus: {
      type: Boolean,
      default: false,
    },
    isUpdatingStatus: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <div class="wo-detail-hero__content">
    <div class="wo-detail-hero__breadcrumb">Work Orders / {{ woNumber }}</div>
    <div class="wo-detail-hero__main">
      <div>
        <div class="wo-detail-hero__title-row">
          <h1>{{ woNumber }}</h1>
          <span class="wo-stage-pill">{{ statusLabel }}</span>
        </div>
        <p>{{ subtitle }}</p>
      </div>
      <div class="wo-detail-hero__actions">
        <button
          type="button"
          class="wo-action-button wo-action-button--ghost"
          :disabled="!canMovePreviousStatus"
          @click="$emit('previous-status')"
        >
          {{ isUpdatingStatus ? 'Updating status...' : `Back to ${previousStatusLabel || 'previous status'}` }}
        </button>
        <button type="button" class="wo-action-button wo-action-button--danger">Cancel WO</button>
      </div>
    </div>
  </div>
</template>
